import './App.css';
import api from './api/axiosConfig';
import { useState, useEffect} from 'react';
import Layout from './components/Layout';
import { Routes, Route } from 'react-router-dom';
import Home from './components/home/Home';
import Header from './components/header/Header';
import Trailer from './components/trailer/Trailer';
import Reviews from './components/reviews/Reviews';
import NotFound from './components/notFound/NotFound';

function App() {

    const [animes, setAnimes] = useState();
    const [anime, setAnime] = useState();
    const [reviews, setReviews] = useState();

    const getAnimes = async () => {

        try
        {

            const response = await api.get("/api/v1/anime");

            // console.log(response.data);

            setAnimes(response.data);

        } 
        catch(err)
        {
            console.log(err);
        }

    }

    const getAnimeData = async (animeId) => {

        try
        {
            const response = await api.get(`/api/v1/anime/${animeId}`);

            const singleAnime = response.data;

            setAnime(singleAnime);

            setReviews(singleAnime.reviewIds);
        }
        catch(error)
        {
            console.log(error);
        }

    }

    useEffect(() => {
        getAnimes();
    },[])

    // console.log(reviews)

  return (
    <div className="App">
        <Header/>

        <Routes>
            <Route path="/" element={<Layout/>}>
                <Route path="/" element={<Home animes={animes} />} ></Route>
                <Route path="/Trailer/:ytTrailerId" element={<Trailer/>}></Route>
                <Route path='/Reviews/:animeId' element={<Reviews getAnimeData = {getAnimeData} anime={anime} reviews={reviews} setReviews={setReviews} />}></Route>
                <Route path="*" element = {<NotFound/>}></Route>
            </Route>
        </Routes>

    </div>
  );
}

export default App;
